import type { UserShape } from '../types';

export const getUserAvatarSrc = (user: UserShape): string | undefined => {
	return user.isAnonymous || !user.avatarUrl ? undefined : user.avatarUrl;
};
